import { Routes, Route } from "react-router-dom";
import LoginRoute from "./LoginRoute";
import PrivateRoute from "./PrivateRoute";

//Routes
import Review from "../../Review.js/Review";
import Area from "../../Area/Area";
import Doctor from "../../Doctor/Doctor";
import Faq from "../../Faq/Faq";
import Help from "../../Help/help";
import Consult from "../../Consult/Consult";
import Lab from "../../Lab/lab";
import Login from "../../Authentication/Login";
import DashboardLayout from "../../ProjectDashboard/DashboardLayout";
import Appointment from "../../Appointment/Appointment";
import Profile from "../../Profile/Profile";
import DoctorAvailability from "../../DoctorAvailability/DoctorAvailability";
import DoctorHoliday from "../../DoctorHoliday/DoctorHoliday";
import Leave from "../../Leave/Leave";
import PatientList from "../../Patient/PatientList";
import UserMaster from "../../User_Master/User_Master";

import DoctorSlotBlock from "../../DoctorSlotBlock/DoctorSlotBlock";

export default function Routers() {
  return (
    <Routes>
      <Route element={<LoginRoute />}>
        <Route path="/Login" element={<Login />} />
      </Route>

      <Route path="*" element={""} />

      <Route element={<PrivateRoute />}>
        <Route path="/" element={<DashboardLayout />} />
        <Route path="/area" element={<Area />} />
        <Route path="/review" element={<Review />} />
        <Route path="/doctor" element={<Doctor />} />
        <Route path="/Faq" element={<Faq />} />
        <Route path="/help" element={<Help />} />
        <Route path="/speciality" element={<Consult />} />
        <Route path="/lab" element={<Lab />} />
        <Route path="/appointment" element={<Appointment />} />
        <Route path="/doctor-availablity" element={<DoctorAvailability />} />
        <Route path="/doctor-holiday" element={<DoctorHoliday />} />
        <Route path="/doctor-slot-block" element={<DoctorSlotBlock />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/leave-type" element={<Leave />} />
        <Route path="/patient" element={<PatientList />} />
        <Route path="/user-master" element={<UserMaster />} />
      </Route>
    </Routes>
  );
}
